var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-text-container w-[100px]"},[_c('highliter',{staticClass:"el-dynamic",attrs:{"value":"Post Text","hide-add":"","hide-right":""}},[_c('p',{staticClass:"post-text",domProps:{"textContent":_vm._s(_vm.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }